module.exports = __webpack_public_path__ + "static/media/pdf.380f7ea1.svg";